<mat-form-field style="width:95%; font-size: 90%;" class="example-form-field" appearance="outline">
  <mat-label>{{'component-datepicker-compro' | translate}}</mat-label>
  <mat-date-range-input [formGroup]="range" [min]="min_date" [max]="today()" [rangePicker]="picker">
    <input matStartDate formControlName="debut" [placeholder]="'component-datepicker-debut' | translate">
    <input matEndDate formControlName="fin"  [placeholder]="'component-datepicker-fin' | translate">
  </mat-date-range-input>
  <mat-hint>{{dateFormat}}</mat-hint>
  <mat-datepicker-toggle (click)="ngOnChanges()" matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker>
    <mat-date-range-picker-actions>
      @if (!attestation) {
        <button matButton matDateRangePickerCancel>{{'cancel' | translate}}</button>
        <button matButton="filled"
          (click)="range.value.debut && range.value.fin && returnDebutFin(range.value.debut.getTime(), range.value.fin.getTime()  ); stampdebut=range.value.debut?.getTime(); stampfin=range.value.fin?.getTime();"
        color="primary" matDateRangePickerApply>{{'apply' | translate}}</button>
      }
      @if (attestation) {
        <div class="d-flex flex-column align-items-center">
          <div class="d-flex timepicker flex-row justify-content-around align-items-center">
            <div class="d-flex flex-column justify-content-center align-items-center">
              <p class="text-center">{{'component-datepicker-horaire-debut' | translate}}</p>
              <ngb-timepicker [(ngModel)]="myTimePickerBegin"></ngb-timepicker>
            </div>
            <div class="d-flex mleft flex-column justify-content-center align-items-center">
              <p class="text-center">{{'component-datepicker-horaire-fin' | translate}}</p>
              <ngb-timepicker [(ngModel)]="myTimePickerEnd"></ngb-timepicker>
            </div>
          </div>
          <div class="d-flex flex-row align-items-center justify-content-end">
            <button matButton matDateRangePickerCancel>{{'cancel' | translate}}</button>
            <button matButton="filled"
              (click)="range.value.debut && range.value.fin && returnDebutFin(range.value.debut.getTime(), range.value.fin.getTime()); stampdebut=range.value.debut?.getTime(); stampfin=range.value.fin?.getTime();"
              color="primary" matDateRangePickerApply>{{'apply' | translate}}</button>
          </div>
        </div>
      }
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>
@if (getTimePickerErrors()) {
  <p>{{getTimePickerErrors() | translate}}</p>
}